import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';

import { AsyncPipe } from '@angular/common';
import { ShActionItemComponent } from '../../../../elements/components/action-item/action-item.component';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShAutocompleteComponent } from '../../_core/autocomplete/autocomplete.component';
import { ShFormSelectBaseComponent } from '../../form-select/base/form-select-base.component';
import { ShFormTypedValueListComplexBaseComponent } from '../base-complex/form-typed-value-list-complex-base.component';
import { TypedValue, TypedValues } from '../typed-values.entity';

interface TypedSetValues {
    [key: string]: Set<string>;
}

@Component({
    selector: 'sh-form-typed-value-list-base',
    templateUrl: '../base-complex/form-typed-value-list-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormTypedValueListBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, ShFormSelectBaseComponent, ShAutocompleteComponent, ShActionItemComponent, AsyncPipe]
})
export class ShFormTypedValueListBaseComponent extends ShFormTypedValueListComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef, formBuilder: UntypedFormBuilder) {
        super(changeDetectorRef, formBuilder);
    }

    propagateChange(formValues: FormValue<TypedValue>[]): void {
        const unwrapped: TypedSetValues = formValues
            .filter(fv => fv.state === FormValueState.SET)
            .map(formValue => FormValue.unwrap(formValue))
            .reduce(this.typedValueListReducer, {} as TypedSetValues);

        const typedValues: TypedValues = this.typedValuesSetToArray(unwrapped);

        super.propagateChange(typedValues as any);
    }

    writeValue(obj: TypedValues | null): void {
        const converted: FormValue<TypedValue>[] = [];
        if (obj !== null) {
            for (const key of Object.keys(obj)) {
                const values: string[] = obj[key];
                for (const value of values) {
                    converted.push(new FormValue<TypedValue>({ type: key, value }));
                }
            }
        }
        super.writeValue(converted);
    }

    private typedValuesSetToArray(typedSetValues: TypedSetValues): TypedValues {
        const result: TypedValues = {};
        for (const key of Object.keys(typedSetValues)) {
            result[key] = [...typedSetValues[key]];
        }
        return result;
    }

    private typedValueListReducer(accumulator: TypedSetValues, current: Partial<TypedValue>): TypedSetValues {
        if (!current.type || !current.value) {
            return accumulator;
        }
        if (!accumulator.hasOwnProperty(current.type)) {
            accumulator[current.type] = new Set();
        }
        accumulator[current.type].add(current.value);
        return accumulator;
    }
}
